import { SVGProps } from 'react';
export const MagicIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17}
    height={16}
    viewBox="0 0 17 16"
    fill="none"
    {...props}
  >
    <g
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      clipPath="url(#a)"
    >
      <path
        strokeWidth={1.5}
        d="m14.767 2.427-.853-.854a.807.807 0 0 0-1.147 0L1.914 12.427a.807.807 0 0 0 0 1.146l.853.854a.799.799 0 0 0 1.147 0L14.767 3.573a.799.799 0 0 0 0-1.146ZM9.673 4.667l2 2"
      />
      <path
        strokeWidth={2}
        d="M3.673 4v2.667M13.007 9.333V12M7.007 1.333v1.334M5.007 5.333H2.34M14.34 10.667h-2.667M7.673 2H6.34"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="currentColor" d="M.34 0h16v16h-16z" />
      </clipPath>
    </defs>
  </svg>
);
